import { WidgetMetadata } from 'components/Dashboard/types';

export enum TLWidgetsEnum {
  FTsOnStandby,
  PlaceholderAssignments,
  MissingExpectedExpenses,
  IncompleteDayPlan,
  RejectedOrUnapprovedAssignmentRequests,
  Comments,
  FaultyCar,
  DeviationReports,
  BookedToEditedByFT,
  NotAcceptedTomorrowsAssignments,
  EstimatedStartTimePassed,
  EstimatedEndTimePassed,
  BookedToTimePassed,
  WorkGearReports,
  FlaggedForSpeeding,
  NotLoadedTyres,
  AssignmentRescheduledToAfterMidnight,
  StandbyTimeAssignments,
  HotelBookedYesterday,
}

export const UPDATE_INTERVAL = 15000; // 15sek

export const DefaultTLWidgets: WidgetMetadata<TLWidgetsEnum>[] = [
  {
    identifier: TLWidgetsEnum.FTsOnStandby,
    shortTitle: 'Fälttestare på standby',
    longTitle: 'Fälttestare på standby',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.PlaceholderAssignments,
    shortTitle: 'Utfyllnadsuppdrag',
    longTitle: 'Utfyllnadsuppdrag som måste ersättas',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.MissingExpectedExpenses,
    shortTitle: 'Saknade kvitton',
    longTitle: 'Saknade förväntade kvitton',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.IncompleteDayPlan,
    shortTitle: 'Ofullständig dagsplan',
    longTitle: 'Ofullständig dagsplan',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.RejectedOrUnapprovedAssignmentRequests,
    shortTitle: 'Annonsförfrågningar',
    longTitle: 'Avvisade eller ej ännu godkända annonsförfrågningar',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.FaultyCar,
    shortTitle: 'Fel på bil',
    longTitle: 'Fel på bil',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.Comments,
    shortTitle: 'Olästa kommentarer',
    longTitle: 'Uppdrag med olästa kommentarer',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.DeviationReports,
    shortTitle: 'Avvikelserapporter',
    longTitle: 'Avvikelserapporter',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.BookedToEditedByFT,
    shortTitle: 'Bokat till-tid ändrad',
    longTitle: 'Bokat till-tid ändrad av fälttestare',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.NotAcceptedTomorrowsAssignments,
    shortTitle: 'Ej accepterade uppdrag imorgon',
    longTitle: 'Ej accepterade uppdrag imorgon - fylls på efter 21.00',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.EstimatedStartTimePassed,
    shortTitle: 'Estimerad starttid passerad',
    longTitle: 'Estimerad starttid passerad',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.EstimatedEndTimePassed,
    shortTitle: 'Estimerad sluttid passerad',
    longTitle: 'Estimerad sluttid passerad',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.BookedToTimePassed,
    shortTitle: 'Bokad till-tid passerad',
    longTitle: 'Bokad till-tid passerad',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.WorkGearReports,
    shortTitle: 'Rapporterad utrustning',
    longTitle: 'Rapporterad utrustning (saknad eller ej verifierad)',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.FlaggedForSpeeding,
    shortTitle: 'Fortkörning',
    longTitle: 'Flaggad för fortkörning',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.NotLoadedTyres,
    shortTitle: 'Ej lastade däck',
    longTitle: 'Ej lastade däck vid hemleverans',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.AssignmentRescheduledToAfterMidnight,
    shortTitle: 'Ombokat till efter midnatt',
    longTitle: 'Uppdrag ombokat till att sluta efter midnatt',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.StandbyTimeAssignments,
    shortTitle: 'Standby-tid',
    longTitle: 'Standby-tid',
    active: true,
  },
  {
    identifier: TLWidgetsEnum.HotelBookedYesterday,
    shortTitle: 'Hotell igår',
    longTitle: 'Hotell bokat igår',
    active: true,
  },
];

export const LongTitles: Record<TLWidgetsEnum, string> =
  DefaultTLWidgets.reduce(
    (titles, widget) => ({
      ...titles,
      [widget.identifier]: widget.longTitle,
    }),
    {} as Record<TLWidgetsEnum, string>
  );
